var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioHairSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6592 5.57351C45.6592 5.57351 31.3108 -8.25859 14.3495 7.65826C14.3495 7.65826 5.22016 15.238 7.08443 37.7837C7.08443 37.7837 5.77986 49.1534 0 49.7263C0 49.7263 6.15022 49.9153 8.38824 46.122C8.38824 46.122 8.57418 53.6987 0.931943 55.5975C0.931943 55.5975 8.57418 55.0288 11.1856 50.6707C11.1856 50.6707 11.9316 55.0284 6.3403 56.5434C6.3403 56.5434 17.3362 56.923 21.9963 51.806C21.9963 51.806 15.846 43.0859 17.8951 38.3501C17.8951 38.3501 23.1153 25.2776 31.3165 23.5717C31.3165 23.5717 28.1469 28.4973 25.3537 30.0138C25.3537 30.0138 38.9598 27.9325 45.2997 23.1963C45.2997 23.1963 46.4142 23.0049 46.4142 25.2795C46.4142 25.2795 47.3435 32.6687 49.7698 35.7021C49.7698 35.7021 50.3317 53.5112 38.5861 57.678C38.5861 57.678 55.9196 56.5449 57.5976 35.8865C57.5896 35.8888 59.4546 6.33195 45.6592 5.57351Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.54786,
    y1: 12.5722,
    x2: 62.3407,
    y2: 24.4641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CA7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E66AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioHairSelected);
export default __webpack_public_path__ + "static/media/radioHair_selected.52854630c744b16cb4566956830967f6.svg";
export { ForwardRef as ReactComponent };